module.exports = __webpack_public_path__ + "static/29-b85501c92c1043949d440c34f543cc14.jpg";